import React from 'react';
import './UpDownCaret.css';

export const UpDownCaret = ({ display, handleClick }) => {
  if (display === 'expand') {
    return (
      <div onClick={handleClick} className="upDownCaret">
        <span className="upCaret" aria-label="Up Arrow" />
      </div>
    );
  } else {
    return (
      <div onClick={handleClick} className="upDownCaret">
        <span className="downCaret" aria-label="Down Arrow" />
      </div>
    );
  }
};
